<template>
  <div class="doctorpc-exam-page">
    <docpc-steps :list="steps" type="exam" :current="stepActive"></docpc-steps>
    <div class="docpc-panel">
      <div class="docpc-form-title">
        <template v-if="stepActive==0">
          视频学习
        </template>
        <template v-if="stepActive==1">
          单选题
        </template>
        <template v-if="stepActive==2">
          多选题
        </template>
      </div>
      <div class="exam-box">
        <template v-if="stepActive==0">
          <div class="exam-video-box">
            <video class="exam-video" preload="metadata" controls="controls" :poster="examVideoPoster" x5-video-player-type="h5-page"><source type="video/mp4" :src="examVideoUrl" /></video>
          </div>
        </template>
        <template v-if="stepActive==1">
          <exam-form ref="refRadio" :arr="examRadio" @change="radioChange"></exam-form>
        </template>
        <template v-if="stepActive==2">
          <exam-form ref="refCheckbox" :arr="examCheckbox" @change="checkboxChange"></exam-form>
        </template>
      </div>
      <div class="docpc-form-btn">
        <div class="btn-item">
          <van-button :color="themeColor" block size="small" @click="examBack()">返回</van-button>
        </div>
        <div class="btn-item">
          <van-button :color="themeColor" block size="small" :disabled="btnDisabled" @click="examNext()">{{btnTxt}}</van-button>
        </div>
      </div>
    </div>

    <van-popup class="contract-popup" v-model="showMsg" close-icon-position="top-left" position="center" :close-on-click-overlay="false">
      <div class="contract-box">
        <!-- <div class="contract-title">{{msg.title}}</div> -->
        <div class="contract-icon">
          <img :src="msg.title=='答案正确'?pass:nopass" alt="">
        </div>
        <div class="contract-text" v-html="msg.desc"></div>
        <div class="contract-btn">
          <van-button :color="themeColor" size="small"  :disabled="btnDisabled" @click="showAnswer()">{{msg.btnTxt}}</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import iconsuccess from "@/assets/docpc/icon_success.png"
import iconwarn from "@/assets/docpc/icon_warn.png"
import iconerror from "@/assets/docpc/icon_error.png"
import pass from "@/assets/docpc/pass.png"
import nopass from "@/assets/docpc/nopass.png"
import docpcSteps from "@/doctor_pc/components/steps/steps.vue"
import examForm from "@/doctor_pc/components/examForm/examForm.vue"
import {
  getQuestions, getVideos, examRecord
} from '@/api/doctorapi';
import {
  Toast,
} from "vant";
import {
  mapState,
  mapActions
} from "vuex";

export default {
  name: 'docpcExamPage',
  components: {
    docpcSteps,
    examForm,
  },
  data() {
    return {
      themeColor: 'linear-gradient(to bottom, #23C7C3, #07A7B4)',
      icon_success: iconsuccess,
      icon_warn: iconwarn,
      icon_error: iconerror,
      nopass: nopass,
      pass: pass,
      baseurl: this.baseUrl,
      steps: ['视频学习','单选题','多选题'],
      stepActive: 0,
      doctor_info: null,
      examVideoUrl: 'https://hlyy.ilvzhou.com/wp-content/uploads/2021/11/55.mp4',
      examVideoPoster: '',
      examRadio: [], // 单选题
      examCheckbox: [], // 多选题
      btnDisabled: false,
      btnTxt: '开始答题',
      showMsg: false,
      msg: {
        status: '', // success;warn;info;error
        icon: '', // vant-ui Icon name
        png: iconsuccess,
        title: '',
        desc: '',
        btnTxt: ''
      },
      msgButtons: [],
    }
  },
  computed: {
    ...mapState(['docpc']),
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      await getQuestions().then(res => {
        console.log('getQuestions', res.data)
        this.examRadio = []
        this.examCheckbox = []
        for(let i in res.data) {
          let ele = res.data[i]
          if (i=='单选') {
            for(let j in ele) {
              let elej = ele[j]
              if (elej.is_enabled==1) {
                elej.value = ''
                this.examRadio.push(elej)
              }
            }
          } else if (i=='多选') {
            for(let j in ele) {
              let elej = ele[j]
              if (elej.is_enabled==1) {
                elej.value = []
                this.examCheckbox.push(elej)
              }
            }
          }
        }
        var compare = function(prop) {
          return function(obj1,obj2) {
            var val1 = obj1[prop];
            var val2 = obj2[prop];
            if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
              val1 = Number(val1);
              val2 = Number(val2);
            }
            if (val1 < val2) {
              return -1;
            } else if (val1 > val2) {
              return 1;
            } else {
              return 0;
            }     
          }
        }
        this.examRadio.sort(compare('sort'))
        this.examCheckbox.sort(compare('sort'))
      }).catch(err => {
          Toast(err.response.data.message)
      })
      await getVideos({
        params: {
          'VideoSearch[id]': 6,
          'VideoSearch[name]': '考试视频'
        }
      }).then(res => {
        console.log('getVideos', res.data.items)
        this.examVideoPoster = this.baseurl + res.data.items[0].image
        if (res.data.items[0].filepath) {
          this.examVideoUrl = res.data.items[0].filepath
        }
      }).catch(err => {
          Toast(err.response.data.message)
      })
    },
    examBack() {
      if (this.stepActive>0) {
        this.stepActive--
      }
      if (this.stepActive==0) {
        this.btnTxt = '开始答题'
        this.$router.replace({
          name: "docpcExam",
        });
      } else {
        this.btnTxt = '提交'
      }
    },
    examNext() {
      if (this.stepActive==0) {
        this.stepActive++
        this.btnTxt = '提交'
      } else if (this.stepActive==1) {
        console.log('单选提交', this.examRadio)
        let all = true
        let allright = true
        for(let i in this.examRadio) {
          let ele = this.examRadio[i]
          if (!ele.value) {
            all = false
          } else {
            if (ele.answer.indexOf(ele.value) == -1) allright = false
          }
        }
        if (!all) {
          Toast('请先完成所有试题！')
        } else {
          if (this.btnTxt == '提交') {
            let req = {
              doctor_id: this.docpc.docpcInfo.doctor.id,
              questions: []
            }
            for(let i in this.examRadio) {
              let ele = this.examRadio[i]
              let arr = []
              arr.push(ele.value)
              req.questions.push({
                exam_id: ele.id,
                doctor_id: this.docpc.docpcInfo.doctor.id,
                answer: arr
              })
            }
            examRecord(req).then(res => {
              console.log('examRecord', res.data)
              if (res.data) {
                this.showMsg = true
                this.msg.title = '答案正确'
                this.msg.desc='恭喜您通过单选环节考核'
                this.msg.btnTxt = '继续考试'
              } else {
                this.$refs.refRadio.isResult = true
                this.showMsg = true
                this.msg.title = '考试不通过'
                this.msg.desc='很抱歉您没有通过单选环节考核'
                this.msg.btnTxt = '查看错题'
              }
            }).catch(err => {
                Toast(err.response.data.message)
            })
          } else if (this.btnTxt == '重新答题') {
            this.$refs.refRadio.isResult = false
            this.$refs.refRadio.showAnswer = false
            for(let i in this.examRadio) {
              let ele = this.examRadio[i]
              ele.value = ''
            }
            this.btnTxt = '提交'
          }
        }
      } else if (this.stepActive==2) {
        console.log('多选提交', this.examCheckbox)
        let all = true
        let allright = true
        for(let i in this.examCheckbox) {
          let ele = this.examCheckbox[i]
          if (ele.value.length==0) {
            all = false
          } else {
            if (ele.answer.length == ele.value.length) {
              for(let j in ele.value) {
                let elej = ele.value[j]
                if (ele.answer.indexOf(elej) == -1) {
                  allright = false
                }
              }
            } else {
              allright = false
            }
          }
        }
        if (!all) {
          Toast('请先完成所有试题！')
        } else {
          if (this.btnTxt == '提交') {
            let req = {
              doctor_id: this.docpc.docpcInfo.doctor.id,
              questions: []
            }
            for(let i in this.examCheckbox) {
              let ele = this.examCheckbox[i]
              req.questions.push({
                exam_id: ele.id,
                doctor_id: this.docpc.docpcInfo.doctor.id,
                answer: ele.value
              })
            }
            console.log('下一步', req)
            examRecord(req).then(res => {
              console.log('examRecord', res.data)
              if (res.data) {
                this.showMsg = true
                this.msg.title = '答案正确'
                this.msg.desc='恭喜您通过多选环节考核'
                this.msg.btnTxt = '继续申请'
              } else {
                this.$refs.refCheckbox.isResult = true
                this.showMsg = true
                this.msg.title = '考试不通过'
                this.msg.desc='很抱歉您没有通过多选环节考核'
                this.msg.btnTxt = '查看错题'
              }
            }).catch(err => {
                Toast(err.response.data.message)
            })
          } else if (this.btnTxt == '重新答题') {
            this.$refs.refCheckbox.isResult = false
            this.$refs.refCheckbox.showAnswer = false
            for(let i in this.examCheckbox) {
              let ele = this.examCheckbox[i]
              ele.value = []
            }
            this.btnTxt = '提交'
          }
        }
      }
    },
    showAnswer() {
      if (this.stepActive==1) {
        if (this.msg.btnTxt == '继续考试') {
          this.stepActive++
          this.showMsg = false
        } else if (this.msg.btnTxt == '查看错题') {
          this.$refs.refRadio.showAnswer = true
          this.showMsg = false
          this.btnTxt = '重新答题'
        }
      } else if (this.stepActive==2) {
        if (this.msg.btnTxt == '继续申请') {
          this.$router.replace({
            name: "docpcBlank",
          });
          this.showMsg = false
        } else if (this.msg.btnTxt == '查看错题') {
          this.$refs.refCheckbox.showAnswer = true
          this.showMsg = false
          this.btnTxt = '重新答题'
        }
      }
    },
    radioChange(e) {
      console.log('radioChange',e)
    },
    checkboxChange(e) {
      console.log('checkboxChange',e)
    }
  }
}
</script>

<style lang='less'>
.doctorpc-exam-page {
  .exam-box {
    margin-bottom: 30px;
  }
  .exam-video-box {
    width: 80%; height: 0; padding-top: 45%; margin: auto; position: relative;
    .exam-video {
      margin: auto; display: block; position: absolute; top: 0; left: 0; right: 0; bottom: 0; width: 100%; height: 100%;
    }
  }
  .contract-box {
    position: relative;
    display: flex;
    flex-direction: column;
    // padding-bottom: 40px;
    background: #fff;
    min-width: 320px;
    .contract-icon {
      height: 48px; padding: 20px 20px 0px; box-sizing: content-box;
      img {
        height: 48px; width: auto; margin: auto; display: block;
      }
    }
    .contract-title {
      background: #fff;
      box-sizing: content-box;
      width: auto;
      line-height: 24px;
      height: 24px;
      font-size: 1.6rem;
      text-align: center;
      padding: 20px 50px 10px;
      background: #fff;
    }

    .contract-text {
      flex: 1;
      height: 50%;
      font-size: 1.4rem;
      text-align: center;
      line-height: 1.5;
      height: 100%;
      padding: 15px;
      overflow-y: auto;
      transition: transform .3s;
      -webkit-overflow-scrolling: touch;
    }

    .contract-btn {
      background: #fff;
      text-align: center;
      padding: 15px;
      // position: absolute;
      // left: 50%;
      // bottom: 0;
      // margin-left: -50px;
      .van-button {
        width: 100px;
      }
    }
  }
}
</style>